var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.infoModal.openModal)?_c('div',{staticClass:"alert"},[_c('v-alert',{attrs:{"elevation":"24","color":_vm.updateColor,"type":_vm.infoModal.type,"dismissible":"","colored-border":"","border":"left"}},[_vm._v(" "+_vm._s(_vm.infoModal.text)+" "),_c('div',{staticClass:"alert__progress",style:({
        backgroundColor: _vm.updateColor,
      })}),_c('div',{staticClass:"alert__progress-animation"})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }